import { render, staticRenderFns } from "./ReceiptEditor.vue?vue&type=template&id=2d6dbeae"
import script from "./ReceiptEditor.vue?vue&type=script&lang=js"
export * from "./ReceiptEditor.vue?vue&type=script&lang=js"
import style0 from "./ReceiptEditor.vue?vue&type=style&index=0&id=2d6dbeae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports